import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import * as S from '../styled';

export const SubscriptionCard = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StyledLink = styled.a`
    display: contents;
    margin-bottom: 25px;
`;

export const DataLink = styled(S.DataLink)`
    margin-bottom: 15px;
    font-size: 24px;
    color: #cce4fb;
    border-bottom-color: #cce4fb;
`;

export const Title = styled.h3`
    margin: 0;
    color: ${COLORS.white};
`;

export const DataText = styled(S.DataText)`
    margin-bottom: 15px;
`;

export const Cost = styled(S.DataText)`
    font-size: 17px;
`;

export const ImgWrap = styled.div`
    width: 100%;
`;

export const Img = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;
